export interface QuestionModel {
  id: string;
  text: string;
  index: number;
  categoryId: number;
  questionType: number;
}
